import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type FeaturesService from 'tio-common/services/features';
import { MANAGE_FIXTURES } from 'tio-employee/utils/tas/manage-fixtures';

/**
 * Dev-only gallery of every manage-screen state, rendered from fixtures. Gated
 * behind the `tasCourseManagement` flag AND non-production, so it can never be
 * reached in prod even if the flag is flipped on.
 */
export default class TasManageGalleryRoute extends Route {
  @service declare features: FeaturesService;
  @service declare router: RouterService;

  beforeModel() {
    const available =
      this.features.isEnabled('tasCourseManagement') &&
      this.features.tioEnvironment !== 'production';
    if (!available) {
      this.router.replaceWith('authenticated.tas.applications');
    }
  }

  model() {
    return MANAGE_FIXTURES;
  }
}
